<template>
  <th
    :style="[styleWidth]"
    :class="[
      col.cssCellClass,
      col.dataField,
      {
        empty: !col.caption,
        sticky: col.lock,
        zindex: col.columnType == $ms.constant.ColumnType.Checkbox && col.hasCheckAll,
      },
      'ms-th-editor',
      'flow-hidden',
      {'multiple-cell-firefox': this.checkIsFirefox() && filterable},
    ]"
    :field="col.dataField"
  >
    <div :class="[filterable ? 'flex-column' : '', this.setHeightOnFirefox() ? 'full-height-parent' : '']">
      <div
        :class="['ms-th-content flex-row', 'flex', {'unset-min-height-content': this.unsetMinHeightContentOnFirefox()}]"
      >
        <div
          v-if="col.columnType == $ms.constant.ColumnType.Checkbox && col.hasCheckAll"
          class="flex justify-center pb-1"
        >
          <ms-checkbox
            :icon="'check'"
            :value="isCheckedAll"
            :checked="isCheckedAll"
            :disabled="col.readOnly || !$parent.editable"
            checkOnly
          />
        </div>
        <div
          class="ms-th-title flex d-flex"
          v-else
          :title="col.tooltip || col.title || col.definition || col.caption"
          :class="[
            {
              'has-lock': col.lockable !== false && !col.group,
              'has-sort': col.sortable !== false,
              'pdl-10': col.lockable === false,
              'pdr-10': !col.sortable,
            },
            dbOptionHeight == 'heightoptionvalue1' ? 'fs-small' : 'fs-big',
          ]"
        >
          <div
            v-if="col.lockable !== false && !col.group && col.dataField !== 'rowAction'"
            class="icon24 lock"
            :class="{locked: col.lock}"
            @click="lockClick"
          ></div>
          <template v-if="col.formatType == $ms.constant.FormatType.Html">
            <p :class="[`text-${col.align || 'left'}`, col.cssClass, 'flex']" ref="thText" v-html="col.caption"></p>
          </template>
          <p v-else :class="[`text-${col.align || 'left'}`, col.cssClass, col.cssHeaderCustom, 'flex']" ref="thText">
            {{ col.caption }}
          </p>
          <div
            class="icon24 mi-arrow-dropdown ml5 mr0"
            :class="[
              {sort: sortStatus == $ms.constant.SortStatus.none},
              {'sort-desc': sortStatus == $ms.constant.SortStatus.desc},
              {'sort-asc': sortStatus == $ms.constant.SortStatus.asc},
            ]"
            @click="sort"
            v-if="col.sortable && col.dataField !== 'rowAction'"
          ></div>

          <div
            v-if="
              col.displayType !== $ms.constant.DisplayColumnType.Text && !col.group && col.dataField === 'rowAction'
            "
            class="row-editor-action delete-all"
            :class="[{locked: col.lock}, 'icon24 ']"
            @click="deleteClick"
            v-tooltip="'Xóa hết dòng'"
          ></div>
        </div>

        <div
          class="ms-resize"
          @mouseup="resizeOff"
          @mousedown="resizeOn"
          v-if="resizeCol && col.dataField !== 'rowAction'"
        ></div>
      </div>
      <template v-if="filterable && col.dataField !== 'rowAction'">
        <component
          v-if="col.filterable && filterComponentName"
          ref="cpnFilter"
          :is="filterComponentName"
          :col="col"
          :colValue="colValue"
          @filter-header="filterHeaderHandle"
          @load-filter-header="loadFilterHeaderHandle"
          :propsData="propsData[col.dataField]"
          isGridEditor
          :dbOptionHeight="dbOptionHeight"
          :filterMode="filterMode"
        ></component>
        <div v-else :class="['filter-container-empty', dbOptionHeight]"></div>
      </template>
    </div>
  </th>
</template>
<script>
import {getCurrentInstance, ref, onMounted, watch, computed} from 'vue';
import {useColumnResize} from '@/setup/grid/resizeColumn.js';
//FilterComponent
import setup from '@/components/gridViewer/columnOption/render-helper.js';
import msThText from '@/components/gridViewer/columnOption/MsThOptionText.vue';
import msThBoolean from '@/components/gridViewer/columnOption/MsThOptionBoolean.vue';
import msThNumber from '@/components/gridViewer/columnOption/MsThOptionNumber.vue';
import msThDate from '@/components/gridViewer/columnOption/MsThOptionDate.vue';
import msThEnum from '@/components/gridViewer/columnOption/MsThOptionEnum.vue';
import msThState from '@/components/gridViewer/columnOption/MsThOptionState.vue';
import msThCombobox from '@/components/gridViewer/columnOption/MsThOptionCombobox.vue';
export default {
  name: 'msThEditor',
  components: {
    msThText,
    msThBoolean,
    msThNumber,
    msThDate,
    msThEnum,
    msThState,
    msThCombobox,
  },
  props: {
    col: {},
    data: {},
    resizeCol: {
      default: true,
      type: Boolean,
    },
    isCheckedAll: {
      default: false,
      type: Boolean,
    },
    /**
     * có filter cột không
     */
    filterable: {
      type: Boolean,
      default: false,
    },
    moduleAutocomplete: {
      type: String,
      default: null,
    },
    colValue: {
      default: false,
      type: Boolean,
    },
    propsData: {
      default: {},
      type: Object,
    },
    levelHeader: {
      default: 0,
      type: Number,
    },
    /**
     * Biến xác định filter combo như nào
     * Dùng luôn giá trị giống querymode của grid. 
     * Vì về cơ bản thì nếu grid đã query local thì thường filter cũng local
     * nvtoan2 13/09/2023
     */
    filterMode: {
      type: String,
      default: 'remote'
    }
  },
  created() {
    const me = this;
    me.widthx = me.col.width;
  },
  data() {
    return {
      cursorX: 0,
      widthx: 0,
      showOption: false,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this._minWidthx = this.col.minWidth || this.$refs['thText']?.offsetWidth + 20;
    });
  },
  emits: ['sort', 'changeLock', 'resizeOn', 'resizeOff', 'changeColumnResize', 'filter', 'deleteClick', 'loadFilter'],

  setup(props, {emit}) {
    const {proxy} = getCurrentInstance();
    let filterComponentName = ref(null);
    const dbOptionHeight = computed(() => {
      return 'heightoptionvalue' + parseInt(proxy.$store?.state?.dbOption?.dbOptions.HeightOption || 2);
    });
    let cpnFilter = ref(null);
    //Hooks
    /**
     * Build component filter theo data type control
     * HTHIEP 14.03.2022
     */
    onMounted(() => {
      filterComponentName.value = getFilterType(props.col);
      widthx.value = props.col._width;
    });

    const {sortStatus, sort, lockClick, updateColWidth, resizeOn, widthx, styleWidth} = useColumnResize({
      props,
      emit,
    });
    //Lấy hàm trong fn chung
    const {getFilterType} = setup(props, {emit});
    onMounted(() => {
      widthx.value = props.col._width;
    });
    /**
     * Xóa tất cả dòng trên gridEditor
     */
    const deleteClick = e => {
      emit('deleteClick');
    };
    /**
     * Trigger sự kiện filter từ con
     * HTHIEP 14.03.2022
     */
    const filterHeaderHandle = value => {
      emit('filter', {col: props.col, value});
    };

    /**
     * Load combobox header
     * NXCHIEN 30.05.2023
     */
    const loadFilterHeaderHandle = (payload, row, dataField) => {
      emit('loadFilter', payload, row, dataField);
    };

    /**
     * Xóa giá trị trên cột filter
     */
    const removeFilter = (trigger = true) => {
      cpnFilter.value.removeFilter(trigger);
    };

    function checkIsFirefox() {
      const isFirefox = /firefox/i.test(navigator.userAgent);
      return isFirefox;
    }

    function setHeightOnFirefox() {
      const isFirefox = checkIsFirefox();
      if (isFirefox && props.levelHeader == 1 && styleWidth._value.width) {
        return true;
      }
      return false;
    }

    function unsetMinHeightContentOnFirefox() {
      const isFirefox = checkIsFirefox();
      if (props.levelHeader > 1 && isFirefox) {
        return true;
      }
      return false;
    }

    return {
      sort,
      sortStatus,
      lockClick,
      updateColWidth,
      resizeOn,
      deleteClick,
      styleWidth,
      getFilterType,
      filterComponentName,
      filterHeaderHandle,
      loadFilterHeaderHandle,
      dbOptionHeight,
      checkIsFirefox,
      setHeightOnFirefox,
      unsetMinHeightContentOnFirefox,
      cpnFilter,
      removeFilter
    };
  },
};
</script>
<style lang="scss" scoped>
.full-height-parent {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.unset-min-height-content {
  min-height: unset !important;
}
.flex-column {
  height: 100%;
}
p {
  margin-block-start: 0px;
  margin-block-end: 0px;
}
.tr-2 {
  p {
    margin-block-start: 4px;
    margin-block-end: 4px;
  }
}
.ms-th-content {
  height: 100%;
}

li.filter-operator-item {
  &.active {
    background-color: #e2f2ff;
  }
}
.flow-hidden {
  overflow: hidden;
}
.ms-th-editor {
  .filter-container-empty {
    height: $ms-filter-grid-height;
    border-top: 1px solid $ms-th-grid-border-color;
    background: #fff;
  }
  .filter-container {
    height: $ms-filter-grid-height;
    border-top: 1px solid $ms-th-grid-border-color;
    .menu-wrapper {
      &.active button {
        background-color: #e2f2ff;
      }
    }
    &.heightoptionvalue2 {
      min-height: 24px !important;
    }
    &.heightoptionvalue1 {
      min-height: 20px !important;
    }

    &.filter-container-boolean {
      .filter-value {
        background: #fff;
      }
    }
    .filter-op {
      position: relative;
      z-index: 2;

      .btn-filter-operator {
        height: $ms-filter-item-grid-height;
        width: $ms-filter-operator-grid-width;
        border: none;
        border-right: 1px dotted $ms-th-grid-border-color;
        background: #fff;
        padding: 0;
        cursor: pointer;
        &:focus,
        &:active,
        &:focus-visible {
          outline: none;
        }
      }
    }
    .filter-value {
      .ms-input-filter-value {
        .ms-input-item,
        .ms-number-item,
        .ms-input--datepicker,
        .combo-box-input input {
          height: $ms-filter-item-grid-height;
          border-radius: 0;
          &:focus {
            outline: none;
          }
        }
        // .ms-container--datepicker {
        // .ms-calendar:before {
        // background: transparent url($ms-image-sprites) no-repeat -191px -336px !important;
        // @include for_breakpoint(desktop-xl) {
        //   background-position: -191px -334px !important;
        // }
        // }
        // }
        .combo-box-input div div {
          background: #fff;
        }
        .icon-combo--dropdown {
          height: $ms-filter-item-grid-height;
          background: #fff;
          border-left: 1px dotted $ms-th-grid-border-color;
          border-radius: 0;
        }
      }
      position: relative;
      z-index: 1;
    }
  }
}
thead {
  th {
    &.rowAction {
      right: 0;
      width: 80px;
      min-width: 80px;
      border-left: 1px dotted $ms-grid-border-color;
      position: sticky;
    }
  }
}

.pdl-10 {
  padding-left: 10px;
}
.pdr-10 {
  padding-right: 10px;
}
.ms-th-editor {
  .sort::before {
    background-position: -48px -120px;
  }
  .sort-desc::before {
    background-position: 0 -120px;
  }
  .sort-asc::before {
    background-position: -24px -120px;
  }

  .ms-resize:hover {
    border-right: 1px solid #ddd;
  }

  .ms-resize:active {
    border-right: 1px solid #ddd;
  }

  .ms-resize {
    width: 5px;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    cursor: col-resize;
  }
}

.heightoptionvalue1 {
  &.ms-th-editor {
    height: 46px !important;
    &.ms-col-th {
      height: 22px !important;
    }
  }
  &.ms-th-content {
    height: 22px !important;
    min-height: 22px !important;
    p {
      margin-block-start: 0px;
      margin-block-end: 0px;
    }
  }
  &.filter-container-empty {
    height: 20px !important ;
    min-height: 20px !important;
  }
}
.heightoptionvalue2 {
  min-height: 26px !important;
  &.ms-th-editor {
    height: 54px !important;
    &.ms-col-th {
      height: 26px !important;
    }
  }
  &.ms-th-content {
    height: 26px !important;
  }
  &.filter-container-empty {
    height: $input-height-custom-small-no-border !important;
    min-height: $input-height-custom-small-no-border !important;
  }
}
.fs-small {
  font-size: $font-size-custom-small;
}
.fs-big {
  font-size: $font-size-custom-big;
}
</style>
